import { useFormik } from 'formik';
import React, { useState } from 'react';
import * as Yup from 'yup';
import { Link } from 'react-router-dom';
import InputBox from 'src/components/Common/InputBox/InputBox';
import { toaster } from 'src/utils/toaster';
import { validation } from 'src/constants/general';
import { ROUTES } from 'src/constants/routes';
import { doForgotPassword } from 'src/services/login';

const ForgotPassword = () => {
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [btnDisabled, setBtnDisabled] = useState(false);

    const onSubmit = async (values: any, helpers: any) => {
        setBtnDisabled(true);
        const payload = {
            email: values.email,
        };
        try {
            const res = await doForgotPassword(payload);
            if (res.status === 200) {
                setSuccess('We have send you an email with instructions on how to reset your password.');
                toaster('success', res.data.message);
                setBtnDisabled(false);
                formik?.handleReset({});
            } else {
                setError(res.data.message);
                setBtnDisabled(false);
            }
        } catch (err: any) {
            setError(err?.response.message);
        }
    };

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Please enter email').email('Please enter proper email'),
        }),
        onSubmit: onSubmit,
    });

    return (
        <div className="flex min-h-screen bg-lightgray items-center justify-center">
            <div className="bg-white rounded-[32px] shadow-lg p-10 max-md:p-8 w-[380px] max-md:w-[350px]">
                <p className="text-2xl text-black80 font-bold text-center mb-5">Forgot Password</p>
                <form onSubmit={formik.handleSubmit}>
                    <div className="mb-4">
                        <InputBox
                            name={'email'}
                            type={'email'}
                            onChange={(e: any) => {
                                formik.handleChange(e);
                                setError('');
                                setSuccess('');
                            }}
                            onBlur={formik.handleBlur}
                            inputId={'floating_filled_forgot'}
                            value={formik.values.email}
                            placeholder="Enter Email"
                            error={formik.errors.email && formik.touched.email ? formik.errors.email : ''}
                            maxLength={validation.email}
                            className={'border border-slate-500'}
                        />
                    </div>
                    <button type="submit" className={`w-full btn-secondary btn-shadow ${btnDisabled ? 'opacity-40' : ''}`} disabled={btnDisabled}>
                        submit
                    </button>
                    {error && <p className="text-red-600 mt-2 text-sm text-center">{error}</p>}
                    {success && <p className="text-green-600 mt-2 text-md text-center">{success}</p>}
                    <Link to={ROUTES.LOGIN} className="">
                        <p className="mt-2 text-md text-center hover:underline hover:text-gray-600">Back to Login</p>
                    </Link>
                </form>
            </div>
        </div>
    );
};

export default ForgotPassword;
